import React from 'react'
import { valueToRiskBracket } from '../../utils/riskConversions'

export const RiskBreakdown = (props) =>
  <div className='risk-profile__breakdown'>
    <div className='breakdown'>
      <BreakdownGoals key='breakdown-goals' {...props} />
      {props.riskProfile.selected === 'detailed' &&
        <BreakdownBuckets key='breakdown-buckets' {...props} />
      }
    </div>
  </div>

const BreakdownGoals = ({ isRetired, riskProfile, yearsToRetirement, inflation }) =>
  <div className='breakdown__goals'>
    <Goal key='goal-1'
      heading={isRetired ? '' : 'Time to retirement'}
      rating={isRetired ? 'retired' : `${yearsToRetirement} yrs`} />
    <Goal key='goal-2'
      heading={`Return goal (CPI + ${riskProfile.rating}%)`}
      rating={`${(inflation * 100) + parseFloat(riskProfile.rating)} %`} />
  </div>

const Goal = ({ heading, rating }) =>
  <div className='goal'>
    <div className='goal__heading'>
      <p>{heading}</p>
    </div>
    <div className='goal__rating'>
      <p>{rating}</p>
    </div>
  </div>

const BreakdownBuckets = ({ riskProfile, clientPronoun, isRetired }) =>
  <div className='breakdown__buckets'>

    <Bucket key='bucket-1'
      heading={'Required Risk'}
      rating={valueToRiskBracket(riskProfile.required_risk)}
      description={`${clientPronoun} risk required to reach a safe retirement`} />
    <Bucket key='bucket-2'
      heading={'Capacity for risk'}
      rating={valueToRiskBracket(riskProfile.capacity)}
      description={isRetired ? 'Investment years remaining (time horizon)' : 'Number of years till retirement (time horizon)'} />
    <Bucket key='bucket-3'
      heading={'Risk tolerance'}
      rating={valueToRiskBracket(riskProfile.tolerance)}
      description={`${clientPronoun} comfort level towards risk`} />
  </div>

const Bucket = ({ heading, rating, description }) =>
  <div className='bucket'>
    <div className='bucket__heading'>
      <h5>{heading}</h5>
    </div>
    <div className='bucket__rating' >
      <p className='bold'>{rating}</p>
    </div>
    <div className='bucket__description'>
      <p>{description}</p>
    </div>
  </div>
